import React from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import UserSessionsTable from './UserSessionsTable';

import useUserSessionData from '../../../../utils/hooks/use_user_session_data';
import Label from '../../../common/Labels/Label';

export const truncateEmail = (inputText) => {
  if (inputText.length < 36) {
    return inputText;
  }
  return `${inputText.substring(0, 36)}...`;
}

export const UserSessionsModal = ({
  userEmail = '',
  sessions = [],
  showDialog = false,
  onDialogToggle = () => {},
  onClose = () => {},
}) => (
  <ConfirmationDialog
    title="Active User Sessions"
    modalAnimationKey="user-sessions-table-modal"
    showDialog={showDialog}
    onDialogToggle={onDialogToggle}
    onClose={onClose}
    hideConfirmButton
    hideCancelButton
  >
    <div className="flex flex-col w-filter-modal m-1">
      <Label className="mb-4">For {userEmail}</Label>
      <UserSessionsTable sessions={sessions} />
    </div>
  </ConfirmationDialog>
)

const UserSessionsModalWithData = ({
  userId = null,
  userEmail = '',
  showDialog = false,
  onDialogToggle = () => {},
  onClose = () => {},
}) => {
  const { data } = useUserSessionData(userId);
  return (
    <UserSessionsModal
      userEmail={userEmail}
      sessions={data}
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onClose={onClose}
    />
  )
}

export default UserSessionsModalWithData;
